import { render } from "./RadarPerformanceChart.vue?vue&type=template&id=2a3ddca2&scoped=true"
import script from "./RadarPerformanceChart.vue?vue&type=script&lang=js"
export * from "./RadarPerformanceChart.vue?vue&type=script&lang=js"

import "./RadarPerformanceChart.vue?vue&type=style&index=0&id=2a3ddca2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a3ddca2"]])

export default __exports__